<template>
  <div class="group -flex -full site-notification -skeleton">
    <div class="notification-flair">
      <div class="notification-type -member-message">
        <span class="author-initial"> </span>
      </div>
    </div>

    <div class="notification-content">
      <h1 class="title"></h1>
      <div class="notification-detail">
        <div class="message" />
        <img class="image" />
        <div class="cta -flex -center" />
      </div>

      <div class="actions">
        <div class="action">
          <span class="btn-txt -reduce"></span>
        </div>
        <div class="action">
          <span class="-no-border -ico-txt" />
        </div>
        <div class="action">
          <span class="-no-border -ico-txt" />
        </div>
      </div>
    </div>
    <div class="notification-view">
      <span class="expand-collapse -no-border -ico-only" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
